module.exports = __webpack_public_path__ + "avatar-placeholder.0876f92fb5eea75f41a4872a88b45c39.hashedasset.svg";